var _defs, _path, _ellipse, _rect, _g, _g2, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _path6, _path7, _g6, _g7, _g8, _g9, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _polygon2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle, _circle2, _path45, _path46, _path47, _path48, _path49, _path50, _g10, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _ellipse7, _path59, _polygon3, _polygon4, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "119ba5e1-a42c-45e9-aad3-66da0c829769",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1101.15,
    height: 790.45,
    viewBox: "0 0 1101.15 790.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d34c74f8-f327-4968-abe7-f899c70f6e3c",
    x1: 286.48,
    y1: 766.2,
    x2: 286.48,
    y2: 93.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M758.6,141.21c-43.78,30.47-100.57,28.5-150.34,12.65s-95.48-44.09-144-64.16A470.28,470.28,0,0,0,337.8,56.92c-61.8-7-130.81,1.53-173.87,50.8-47.95,54.87-44.27,153.82,7.59,204.19,26.38,25.62,60.93,38.19,91,58.19s58,53.22,55.45,91.83c-2.38,35.74-30,63.16-58.57,80.37-22.08,13.3-49.29,27.82-51.95,55.37-2.57,26.65,20.3,47.54,42.14,59.41,71.25,38.75,159,38.38,230-1,25.32-14,48.6-32.71,75.15-43.65,69.73-28.73,146.56.19,220.39,10.76a443.07,443.07,0,0,0,187.44-13.56c36.57-10.74,73.27-27.15,98.95-57.73,18.52-22,30.06-49.95,40.9-77.5q17.32-44.08,33.31-88.78c6.39-17.89,12.69-36.12,14.34-55.26,3-34.69-9.62-69-26.79-98.24-40.77-69.49-109.45-118.36-183.78-130.77s-153.09,11.83-210.77,64.88",
    transform: "translate(-49.43 -54.77)",
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176,
    cy: 697.43,
    rx: 176,
    ry: 29.99,
    fill: "#009ddd",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226.43,
    y: 183.98,
    width: 796.46,
    height: 377.59,
    rx: 30.34,
    ry: 30.34,
    fill: "#009ddd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.1,547.7H310.29a27.94,27.94,0,0,1-27.94-27.94V335.35a27.93,27.93,0,0,1,27.94-27.94H439.1Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff",
    opacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1037.87,547.7H909.07V307.41h128.8a27.93,27.93,0,0,1,27.94,27.94V519.76A27.94,27.94,0,0,1,1037.87,547.7Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff",
    opacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 702.9,
    y: 252.63,
    width: 156.74,
    height: 240.29,
    fill: "#fff",
    opacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.16,
    y: 252.63,
    width: 156.74,
    height: 240.29,
    fill: "#fff",
    opacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.42,
    y: 252.63,
    width: 156.74,
    height: 240.29,
    fill: "#009ddd",
    opacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.94,413.82a2.27,2.27,0,0,1-2.27-2.27V405a2.27,2.27,0,1,1,4.54,0v6.57A2.27,2.27,0,0,1,527.94,413.82Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M516.44,418.58a2.26,2.26,0,0,1-1.6-.66l-4.64-4.65a2.27,2.27,0,1,1,3.2-3.21l4.65,4.65a2.27,2.27,0,0,1-1.61,3.87Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M544.09,446.22a2.28,2.28,0,0,1-1.61-.66l-4.64-4.65a2.27,2.27,0,1,1,3.21-3.2l4.64,4.64a2.27,2.27,0,0,1-1.6,3.87Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550.77,430.08H544.2a2.27,2.27,0,0,1,0-4.54h6.57a2.27,2.27,0,0,1,0,4.54Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M539.44,418.58a2.27,2.27,0,0,1-1.6-3.87l4.64-4.65a2.27,2.27,0,1,1,3.21,3.21l-4.64,4.65A2.3,2.3,0,0,1,539.44,418.58Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M540,427.81a12,12,0,0,0-21.77-7A16.87,16.87,0,0,0,494,429.89a11.34,11.34,0,0,0-3.89.23,11.3,11.3,0,0,0-8.38,13.58,11.27,11.27,0,0,0,11,8.69H523a13.31,13.31,0,0,0,3-.35,13.05,13.05,0,0,0,9.79-15.19A12,12,0,0,0,540,427.81Zm-15,19.81a8.08,8.08,0,0,1-2,.23H492.68a6.75,6.75,0,0,1-1.55-13.31,6.86,6.86,0,0,1,1.56-.19,6.6,6.6,0,0,1,2.15.36,2.29,2.29,0,0,0,1.86-.18,2.26,2.26,0,0,0,1.09-1.51,12.34,12.34,0,0,1,22.89-3.45.31.31,0,0,1,.05.1,2.3,2.3,0,0,0,2.07,1.19h.25a8.46,8.46,0,0,1,7.24,4,8.78,8.78,0,0,1,1,2.5,9.19,9.19,0,0,1,.23,1.87A8.51,8.51,0,0,1,525,447.62Zm6.08-18.54a13.2,13.2,0,0,0-7-2.73,16.79,16.79,0,0,0-2.25-2.78A7.47,7.47,0,1,1,534,432.23,13.08,13.08,0,0,0,531.08,429.08Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.44,425a13,13,0,0,0-11.69-10,16.87,16.87,0,0,0-27.63-1A16.87,16.87,0,0,0,653,425.26a11.29,11.29,0,1,0-1.29,22.51H682a13.29,13.29,0,0,0,3-.35,13.05,13.05,0,0,0,8.38-6.34h1.34a13.31,13.31,0,0,0,3-.35A13.06,13.06,0,0,0,707.44,425Zm-19.77,16A8.5,8.5,0,0,1,684,443a8.76,8.76,0,0,1-2,.23H651.66a6.75,6.75,0,0,1-1.55-13.32,6.87,6.87,0,0,1,3,0,5.94,5.94,0,0,1,.72.21,2.29,2.29,0,0,0,3-1.7,12.37,12.37,0,0,1,12.08-9.83,11.8,11.8,0,0,1,1.69.12,12.34,12.34,0,0,1,9.17,6.36,2.24,2.24,0,0,0,2.06,1.19H682a8.5,8.5,0,0,1,5.63,14.85Zm9-4.77a8.18,8.18,0,0,1-1.77.23,12.86,12.86,0,0,0-.23-4.81,13,13,0,0,0-11.69-10,16.88,16.88,0,0,0-9.32-7,12.32,12.32,0,0,1,18.74,3.62,2.26,2.26,0,0,0,2.07,1.19h.25a8.5,8.5,0,0,1,2,16.77Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998,446.46l-1.46-.85,1.46-.84a1.14,1.14,0,0,0-1.13-2l-1.47.85V442a1.14,1.14,0,1,0-2.27,0v1.67l-1.45-.84a1.14,1.14,0,0,0-1.13,2l1.45.83-1.45.84a1.13,1.13,0,0,0-.41,1.55,1.14,1.14,0,0,0,1,.57,1,1,0,0,0,.56-.16l1.45-.83v1.69a1.14,1.14,0,0,0,2.27,0v-1.69l1.47.84a1,1,0,0,0,.56.16,1.16,1.16,0,0,0,1-.57A1.14,1.14,0,0,0,998,446.46Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.17,437l-1.46-.84,1.46-.85a1.12,1.12,0,0,0,.41-1.54,1.13,1.13,0,0,0-1.55-.42l-1.46.85v-1.68a1.14,1.14,0,0,0-2.27,0v1.67l-1.45-.83a1.13,1.13,0,1,0-1.13,2l1.45.84-1.45.83a1.13,1.13,0,0,0,.57,2.12,1.12,1.12,0,0,0,.56-.15l1.45-.84v1.7a1.14,1.14,0,0,0,2.27,0v-1.7L990,439a1.18,1.18,0,0,0,.57.15,1.14,1.14,0,0,0,.57-2.12Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.36,446.46l-1.46-.85,1.46-.84a1.14,1.14,0,0,0-1.13-2l-1.47.85V442a1.14,1.14,0,1,0-2.27,0v1.67l-1.44-.84a1.14,1.14,0,0,0-1.14,2l1.45.83-1.45.84a1.13,1.13,0,0,0-.41,1.55,1.14,1.14,0,0,0,1,.57,1.1,1.1,0,0,0,.57-.16l1.44-.83v1.69a1.14,1.14,0,0,0,2.27,0v-1.69l1.47.84a1,1,0,0,0,.56.16,1.14,1.14,0,0,0,.57-2.12Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.44,422.4a13.05,13.05,0,0,0-11.69-10,16.88,16.88,0,0,0-30.08,3.53,11.29,11.29,0,1,0-1.29,22.51H975a2.27,2.27,0,0,0,0-4.54h-3.65a6.72,6.72,0,0,1-6.56-5.2,6.77,6.77,0,0,1,5-8.12,6.84,6.84,0,0,1,3.72.17,2.27,2.27,0,0,0,3-1.69,12.34,12.34,0,0,1,22.94-3.35,2.26,2.26,0,0,0,2.06,1.19h.26a8.5,8.5,0,0,1,2,16.77,8.74,8.74,0,0,1-2,.23h-1.89a2.27,2.27,0,0,0,0,4.54h1.89a13,13,0,0,0,12.69-16.05Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848,436.1a13.29,13.29,0,0,1-3,.35h-5.17a2.27,2.27,0,0,1,0-4.54H845a8.76,8.76,0,0,0,2-.23,8.5,8.5,0,0,0-2-16.77h-.26a2.24,2.24,0,0,1-2.06-1.19,12.35,12.35,0,0,0-23,3.35,2.26,2.26,0,0,1-3,1.69,6.76,6.76,0,0,0-7.9,2.85,6.76,6.76,0,0,0,5.74,10.3h7.6a2.27,2.27,0,0,1,0,4.54h-7.6a11.29,11.29,0,0,1-9.6-17.22,11.35,11.35,0,0,1,10.89-5.29A16.87,16.87,0,0,1,846,410.41a13,13,0,0,1,2,25.69Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "782.21 381.09 785.41 381.09 778.56 397.63 780.2 385.71 777.15 385.71 779.56 372.5 785.79 372.5 782.21 381.09",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.72,413.56a2.27,2.27,0,0,1-2.26-2.27v-6.57a2.27,2.27,0,1,1,4.53,0v6.57A2.27,2.27,0,0,1,360.72,413.56Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46,429.82h-6.57a2.27,2.27,0,0,1,0-4.54h6.57a2.27,2.27,0,0,1,0,4.54Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.72,452.65a2.27,2.27,0,0,1-2.26-2.27v-6.57a2.27,2.27,0,0,1,4.53,0v6.57A2.27,2.27,0,0,1,360.72,452.65Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.55,429.82H377a2.27,2.27,0,0,1,0-4.54h6.56a2.27,2.27,0,0,1,0,4.54Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.72,439.56a12,12,0,1,1,12-12A12,12,0,0,1,360.72,439.56Zm0-19.48a7.47,7.47,0,1,0,7.48,7.47A7.48,7.48,0,0,0,360.72,420.08Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.23,418.32a2.26,2.26,0,0,1-1.61-.66l-2.32-2.32a2.27,2.27,0,0,1,3.21-3.21l2.32,2.32a2.27,2.27,0,0,1-1.6,3.87Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.9,443.64a2.27,2.27,0,0,1-1.6-3.87l2.32-2.32a2.27,2.27,0,1,1,3.21,3.21L348.51,443A2.3,2.3,0,0,1,346.9,443.64Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.55,443.64a2.28,2.28,0,0,1-1.61-.66l-2.32-2.32a2.27,2.27,0,0,1,3.21-3.21l2.32,2.32a2.27,2.27,0,0,1-1.6,3.87Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,418.32a2.27,2.27,0,0,1-1.6-3.87l2.32-2.32a2.27,2.27,0,0,1,3.21,3.21l-2.32,2.32A2.28,2.28,0,0,1,372.22,418.32Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 265.53,
    y: 263.1,
    width: 91.54,
    height: 28,
    rx: 14,
    ry: 14,
    fill: "#f6f7f9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 422.14,
    y: 263.1,
    width: 91.54,
    height: 28,
    rx: 14,
    ry: 14,
    fill: "#f6f7f9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 578.76,
    y: 263.1,
    width: 91.54,
    height: 28,
    rx: 14,
    ry: 14,
    fill: "#f6f7f9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 735.38,
    y: 263.1,
    width: 91.54,
    height: 28,
    rx: 14,
    ry: 14,
    fill: "#f6f7f9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 263.1,
    width: 91.54,
    height: 28,
    rx: 14,
    ry: 14,
    fill: "#f6f7f9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M471.57,423.59s-29.84-29.95-39.18-30.38c-5.37-.24-11.57-2.93-15.87-5.16l-1.1-.58c1-1.31.47-2-.05-2.37a2.4,2.4,0,0,0-.55-.26l-71.14-56.2c.67-1.07-3.11-13-3.11-13l-3.78-12.43-8-10.35s2.23-7.24,0-10.86-1.77-12.14-3.33-32.79-10-21.93-10-21.93S282.76,205.58,279,206.22c-3.52.59-8.22-6.22-8.84-7.14l-.07-.1s0,.09-.06.24q.08-1.17.06-2.37h0c0-.29,0-.57,0-.86h0A49.46,49.46,0,0,1,273,186c.28-.69.56-1.34.84-1.94A39.25,39.25,0,0,0,301.1,157c.06-.23.11-.46.17-.69,1.61.2,3.24.29,4.82.35h.3a13.38,13.38,0,0,1-1.07-3.41H305a15.19,15.19,0,0,1-.19-1.77c.12.39.25.78.4,1.17a21.76,21.76,0,0,1,1.62-10.53c1.83-4.65,4.64-8.88,6.65-13.46a20.35,20.35,0,0,0,2.07-9.87,11.67,11.67,0,0,0-.91-3.56,1,1,0,0,0,0,.16c0,.25,0,.5,0,.76a9.51,9.51,0,0,0-4.64-5.65c-1.8-.88-3.91-1.1-5.58-2.21-4.93-3.26-4.65-8.54-11.22-10.24-5.28-1.37-10.87-1.35-16.2-2.78-11.5-3.06-21.22-1.15-32.34,2.79-8.32,3.33-16.44,7.6-22.72,13.93s-10.56,15-10,23.82a16.31,16.31,0,0,0,2.31,7.92c1.33,2.08,3.33,3.81,4,6.17.8,2.72-.31,5.6-.32,8.44,0,2.58,1.81,5.6,4.24,5.56a2.91,2.91,0,0,0,1-.09,4.72,4.72,0,0,0,2.18-1.51c.15.34.3.68.46,1,.38.81.8,1.61,1.25,2.38-.07.43-.15.86-.25,1.27a19.25,19.25,0,0,1-5.05,8.41,3.79,3.79,0,0,0-1.7.54h0l-.49.24-16.22,8.18-1.78,0c-5.24-.07-20.35-.19-22.67.74-2.82,1.15-30.09,3.34-30.09,3.34s-14.53.85-13.78,22c0,0-5.49,17.93-7.12,20.91s-11.26,32.07-11.26,32.07L105.42,319l-1.34,61.59s0,7-.22,15.31c-.49,13.82-1.18,25.28-2.14,27.27h0l1,.4a4,4,0,0,1-.16.46l.88-.2,6.23,2.32S94.3,443.6,105.42,448c5.49,2.17,18.5,8.46,30.27,14.27a75.86,75.86,0,0,0,3.07,38.52,63.9,63.9,0,0,1,.75,21.86c-1.77,11.07.15,47.69.15,47.69l-.15,64.16s2.37,41.16,4.45,50-4.45,12.5-4.45,12.5,4.27,24.19,9.45,27.4c-.1.47-.22,1-.35,1.47a79.79,79.79,0,0,1-3.91,11.58c-3.56,8.37-1.33,14.33-1.33,14.33s.29,11.79,21.63,14.2,20.46-12.5,18.68-18.17c-1.09-3.47-.3-14.25.49-22.11.06-.63.12-1.24.18-1.82,1.31-.84,3-2.63,5-6.45,4.14-8.23,0-28.1-3-34.63s-.3-13.63-.3-13.63-3.26-36.62,0-39.73,2.67-17,2.67-17l5.34-28.68,6.22-12.2,1.78-26.69,5-23.56s2.07-2,3.85-20.72,4.15-12.78,4.15-12.78c-.88,12.49,5.93,18.74,5.93,18.74l1.86,32.65s2.29,24.4,6.08,30.37,0,13.34,0,13.34,1.25,23.27.15,30.09,4.36,22.43,4.36,22.43l1.48,28.1s-8.89,25.26-4.74,33.5,2.08,17.88,2.08,17.88a4.17,4.17,0,0,0,.88,1.49c-.11.43-.22.87-.32,1.33a79,79,0,0,0-1.3,9.1s2.22,3,12.15,6.67,7.71,9.94,9.19,13.92,11.56,7.51,31.42,6.66,7.26-15.18,7.26-15.18-10.37-14.62-13.93-16.61c-1.23-.69-2.52-2.94-3.7-5.63-.22-.5-.43-1-.64-1.54l.83-.21s5.29-42,1.44-46,1.27-31.23,1.27-31.23,2.58-9.07,1.4-11.63,1.18-12.49,1.18-12.49,1.78-27-1.49-33.21,1.78-42.59,1.78-42.59,2.08-34.06,7.32-46.26c1-2.24,1.56-7,1.92-13.2,2.9-1.41,4.7-2.49,4.7-2.49s6-80.9,2.44-90.91A58.57,58.57,0,0,1,293,365l6.89-24.48s4.45,12.13,7.34,13.62,6.45,7.46,6.45,7.46l30.45,24.27,23.57,17.24,20.9,17.25A29.3,29.3,0,0,1,392.37,409l.74.27c3.86,1.39,8.76,3.11,7.56,2.41-.66-.39-.31-2.58.72-5.45l.89.86A171.74,171.74,0,0,0,416,418.48c22.11,16.88,33.72-2,33.72-2s11.12,9.64,16.6,11.77S471.57,423.59,471.57,423.59Z",
    transform: "translate(-49.43 -54.77)",
    fill: "url(#d34c74f8-f327-4968-abe7-f899c70f6e3c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29,725s2.12,3,11.55,6.62,7.32,9.86,8.73,13.81,11,7.46,29.86,6.61,6.9-15.06,6.9-15.06-9.86-14.51-13.24-16.48c-1.17-.68-2.39-2.92-3.52-5.58a104.23,104.23,0,0,1-3.81-11.61s-31.12,4.23-33.37,7.33a15.48,15.48,0,0,0-1.85,5.33A82.11,82.11,0,0,0,234.29,725Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#b07473"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5,749.82s.28,11.69,20.56,14.08,19.43-12.39,17.74-18c-1-3.44-.28-14.14.47-21.94.47-5,.94-8.77.94-8.77s-34.08.71-33.8,2.54a22.87,22.87,0,0,1-.93,6.4,81.53,81.53,0,0,1-3.71,11.49C148.39,743.9,150.5,749.82,150.5,749.82Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#b07473"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M391,401.2c.58,1.2,2,3.24,5.47,6.64a165.64,165.64,0,0,0,13.05,11.31c21,16.75,32-2,32-2s10.56,9.58,15.78,11.69,5-4.65,5-4.65S434,394.51,425.12,394.08c-5.11-.24-11-2.9-15.08-5.12-3-1.64-5.06-3-5.06-3l-7.62,7.35-6.64,6.4S390.45,400,391,401.2Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#efb7b9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M237.39,710.67a15.48,15.48,0,0,0-1.85,5.33c5.24,7.63,36.41-.37,39-1a104.23,104.23,0,0,1-3.81-11.61S239.64,707.57,237.39,710.67Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.48,724.11a3,3,0,0,0,.65.42c5.07,2.3,31-.06,31-.06a2.67,2.67,0,0,0,2.16-.53c.47-5,.94-8.77.94-8.77s-34.08.71-33.8,2.54A22.87,22.87,0,0,1,155.48,724.11Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.12,500.84a66,66,0,0,1,.72,21.68c-1.69,11,.14,47.32.14,47.32l-.14,63.66s2.25,40.84,4.22,49.56-4.22,12.4-4.22,12.4,4.22,25.07,9.29,27.38,31-.06,31-.06,3.1,1.13,7-7,0-27.88-2.82-34.37-.28-13.52-.28-13.52-3.1-36.33,0-39.42,2.53-16.9,2.53-16.9l5.07-28.45L204.58,571l1.69-26.48,4.79-23.37s2-2,3.66-20.57,3.94-12.67,3.94-12.67c-.84,12.39,5.63,18.58,5.63,18.58l1.77,32.4s2.18,24.22,5.78,30.13,0,13.24,0,13.24,1.19,23.1.14,29.86,4.14,22.25,4.14,22.25l1.41,27.89s-8.45,25.06-4.5,33.23,2,17.74,2,17.74c3.1,9.87,39.75,0,39.75,0s5-41.68,1.37-45.62,1.21-31,1.21-31,2.45-9,1.33-11.54,1.12-12.4,1.12-12.4,1.69-26.76-1.41-32.95,1.69-42.25,1.69-42.25,2-33.8,6.95-45.91c.92-2.22,1.49-6.93,1.83-13.14,1.49-27.61-1.83-84.87-1.83-84.87l-13.78-18.88-14.38-.76L245,373.15l-26.06-1.38L193.2,370.4l-31.44-1.67s-6.47,58-15.64,83.1a66.07,66.07,0,0,0-2.91,10.76A78.45,78.45,0,0,0,146.12,500.84Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#444053"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.74,180l11.2,27.46,24.29,4s12.89,4.44,12.25-6.55c-.33-5.82,1.47-12,3.23-16.52a56.47,56.47,0,0,1,3.11-6.71s-49.85-28.1-47.1-18.59a12.45,12.45,0,0,1,.12,6.4C228.35,175.75,222.74,180,222.74,180Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#efb7b9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "202.47 325.23 147.83 325.23 150.64 344.38 203.59 344.38 202.47 325.23",
    fill: "#b07473"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.47 325.23 147.83 325.23 150.64 344.38 203.59 344.38 202.47 325.23",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M391,401.2c.58,1.2,2,3.24,5.47,6.64,1.85-5.43,6-13.33,10.2-16A11,11,0,0,0,410,389c-3-1.64-5.06-3-5.06-3l-7.62,7.35Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M383.71,408.45s1.86.72,4.08,1.55c3.67,1.39,8.33,3.1,7.18,2.39-1.82-1.12,4.52-17.32,10.89-21.4,4.74-3,3.85-4.44,3.08-5a1.9,1.9,0,0,0-.51-.25l-5.14-1.84Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#e1e7ef"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M229.72,163.13a12.45,12.45,0,0,1,.12,6.4,38.14,38.14,0,0,0,43.87,18.9,56.47,56.47,0,0,1,3.11-6.71S227,153.62,229.72,163.13Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.42,150a38.1,38.1,0,1,0,38.09-38.09A37.86,37.86,0,0,0,225.42,150Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#efb7b9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.9,380.07l24.29,1.09,28,1.25,13.66.62,1-9.14,10.79-94.58,3.59-71.61h-9.72l-26.82-4.44-9.53-3.56h0L214.72,195l-10.14,20.71-3.38,94.84-8,59.83Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#e1e7ef"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.07,275.09s9.71-42.46,16.47-50.7c0,0-2.53-14.58-8.13-16.48s8.56-4.65,8.56-4.65l8.66,3,8.66,3.54s-7.61,6.76-6.34,15.63A22.79,22.79,0,0,0,254,237.27c2.32,5.92,2.74,53.87,0,60.21s-2.32,20.28-2.32,20.28L246,345l-1.9,32.74L223.59,393l-14.37-18Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.22,274.24s9.72-42.46,16.48-50.7c0,0-2.54-14.57-8.13-16.47s8.55-4.65,8.55-4.65l8.66,3,8.66,3.54s-7.6,6.76-6.33,15.63a22.85,22.85,0,0,0,1,11.83c2.33,5.91,2.75,53.87,0,60.2s-2.32,20.28-2.32,20.28l-5.7,27.25-1.91,32.74-20.49,15.21-14.36-17.95Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#b07473"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M270.89,199.25l-21.11,7s10.55,5.44,10.56,21.5C260.34,227.77,271.08,214.66,270.89,199.25Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.89,198.4l-21.11,7s10.55,5.44,10.56,21.49C260.34,226.92,271.08,213.82,270.89,198.4Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#e1e7ef"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.05,178.72s10.37,17.89,24.73,27.55c0,0-8.7-3.22-24.73,9C225.05,215.3,215.1,179.53,225.05,178.72Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M225.05,177.88s10.37,17.88,24.73,27.55c0,0-8.7-3.22-24.73,9C225.05,214.46,215.1,178.69,225.05,177.88Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#e1e7ef"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M383.71,408.45s1.86.72,4.08,1.55c6.28-12.14,19-22.27,21.15-24a1.9,1.9,0,0,0-.51-.25l-5.14-1.84Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M241.12,438.59c.64,14.15,8.45,40.35,8.45,40.35,9.82,13.6,31.56,3.62,39.27-.54,1.49-27.61-1.83-84.87-1.83-84.87l-13.78-18.88-14.38-.76,10.79-94.58,3.59-71.61h-5.37c-1.74,7.28-4.48,19.58-4,22.6.7,4.37-6.63,47.89-6.63,47.89l-9.06,55.44-2.48,15.11c.82,2.53.21,13.28-.72,24.41-.27,3.11-.55,6.26-.83,9.26-1,10.27-2,18.86-2,18.86C240.91,411,241.12,438.59,241.12,438.59Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M242.81,437.74c.64,14.16,8.45,40.35,8.45,40.35,12,16.69,42-2.11,42-2.11s5.7-80.27,2.32-90.2a60.23,60.23,0,0,1-2.95-19.65l6.54-24.29s4.23,12,7,13.52,6.12,7.39,6.12,7.39l28.94,24.08,22.39,17.11,19.86,17.11c1.48-17.74,24.93-35.27,24.93-35.27L340.83,330c.63-1.06-3-12.89-3-12.89l-3.59-12.33-7.6-10.27s2.11-7.18,0-10.77-1.69-12-3.17-32.53S314,229.46,314,229.46,283,207.91,279.36,208.54c-3.35.6-7.82-6.16-8.41-7.08l-.06-.1s-6,23.73-5.33,28.1-6.63,47.88-6.63,47.88l-9.06,55.44-2.48,15.12c1.84,5.66-3.52,52.52-3.52,52.52C242.6,410.14,242.81,437.74,242.81,437.74Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#67647e"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.21,462.59c12.11,6.24,23.34,12.19,23.34,12.19s18.74,6.2,26.34-29l21.83-59.85s.57-1.78,1.47-4.76c.74-2.43,1.7-5.67,2.73-9.39,4.29-15.25,10-38.54,7.91-47.68v-.71l-.43-81.81s2.31-38.46.87-41.63a1.66,1.66,0,0,0-.11-.24h0L214.72,195l-10.14,20.71-3.38,94.84-8,59.83-31.44-1.67s-6.47,58-15.64,83.1A66.07,66.07,0,0,0,143.21,462.59Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M114.44,448.45c10.57,4.36,50.42,25.48,50.42,25.48s18.74,6.21,26.34-29L213,385.08s15.35-47.75,12.11-61.83v-.71l-.43-81.82s2.31-38.45.87-41.62c-1.35-3-3-11.91-2.29-19.49.05-.4.09-.8.14-1.2l-.48.26-15.42,8.11-1.69,0c-5-.07-19.34-.19-21.54.74-2.68,1.13-28.59,3.31-28.59,3.31s-13.8.84-13.09,21.86c0,0-5.22,17.79-6.76,20.74s-10.71,31.82-10.71,31.82l-10.71,55.22-1.26,61.11s-.14,39-2.25,42.25l7.6,3S103.88,444.08,114.44,448.45Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#67647e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M151.91,413.8l4.79,6.34s29.29,53.09-3.38,45.35S125.43,431,125.43,431l2-18.59Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#efb7b9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M193.17,700.39c-.7-.14-12.11-4.93-20-4.93s-18.45-.85-17.18,1.27,16.48,2.39,20.84,4.5,13.66,7.89,14.51,8.17S193.17,700.39,193.17,700.39Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.75,676.45c-.14.84-16.9,19.66-26.19,18.84S271.75,676.45,271.75,676.45Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M266.82,631.52s-18,45.77-23.8,48.17-6.62-5.64-3.52-7.89S252.18,654.76,266.82,631.52Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M174.16,616.45s-3,16.9,4.5,27.89S174.16,616.45,174.16,616.45Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M221.48,463.23c.32-.26-26.9-1.41-26.9-1.41S206.83,475.2,221.48,463.23Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.1,474.92l-16.48,1.55S207.39,483.51,218.1,474.92Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M315.55,299.31s14.79,2,16.2,6.34S315.55,299.31,315.55,299.31Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M341.74,335.5c-1.12-.42-10.28-3.1-16.75-1.41s-15.64-3.1-15.64-3.1-9.29-.28-7.46,1,7.32.7,10.42,2.54,11.25,3.38,13.3,2.53S341.74,335.5,341.74,335.5Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M249.87,332.78l.34,7.65s25.91-63.65,32.38-77.32,2.83-43.37,2.83-43.37l-3.67-.85L271,201.46l-.06-.1s-6,23.73-5.33,28.1-6.63,47.88-6.63,47.88Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#67647e"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198,199.46S208.65,309,225.14,322.54l-.43-81.82s2.31-38.45.87-41.62c-1.35-3-3-11.91-2.29-19.49l-.34-.94-15.42,8.11-1.69,0-1,14.61Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#67647e"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M249.87,332.78l.34,7.65s25.91-63.65,32.38-77.32,2.83-43.37,2.83-43.37l-3.67-.85L271,201.46l-.06-.1s-6,23.73-5.33,28.1-6.63,47.88-6.63,47.88Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M198,199.46S208.65,309,225.14,322.54l-.43-81.82s2.31-38.45.87-41.62c-1.35-3-3-11.91-2.29-19.49l-.34-.94-15.42,8.11-1.69,0-1,14.61Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 203.6,
    cy: 296.08,
    r: 3.15,
    fill: "#444053"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.44,
    cy: 342.69,
    r: 3.15,
    fill: "#444053"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M225.42,150a37.86,37.86,0,0,0,3.47,15.89l.5-.6c6.15-7.68,7.46-18.37,13-26.55,2-2.92,4.57-5.56,7.87-6.64s7.32-.25,9.35,2.62c1.28,1.82,1.66,4.2,3,6,2.58,3.39,7.53,3.3,11.68,2.67s8.87-1.34,12.07,1.43,3.43,7.53,6,10.74c2,2.45,4.92,3.57,8.05,4.1a38.09,38.09,0,1,0-75-9.63Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M246.81,101.17c-7.9,3.31-15.62,7.54-21.59,13.83s-10,14.86-9.55,23.63a16.87,16.87,0,0,0,2.2,7.86c1.26,2.06,3.16,3.78,3.83,6.12.76,2.7-.3,5.56-.3,8.37s2.07,6.16,4.71,5.42a5.1,5.1,0,0,0,2.44-1.93c6.14-7.67,7.45-18.37,12.94-26.54,2-2.92,4.57-5.56,7.87-6.64s7.33-.26,9.36,2.62c1.28,1.82,1.65,4.2,3,6,2.57,3.39,7.53,3.3,11.67,2.67s8.87-1.34,12.08,1.42,3.43,7.53,6,10.74c3.15,3.91,8.71,4.42,13.64,4.62-2-4.49-1.3-9.83.44-14.44s4.41-8.81,6.32-13.35a21,21,0,0,0,2-9.8c-.29-3.35-2-6.72-4.94-8.22-1.71-.88-3.72-1.1-5.31-2.2-4.69-3.23-4.42-8.48-10.66-10.16-5-1.36-10.33-1.34-15.39-2.75C266.61,95.36,257.38,97.26,246.81,101.17Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#585268"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M135.71,418.31s-8.59,8.45-9.72,8.31-2.81-7.61-2.81-7.61Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.87,417.46s-8.59,8.45-9.72,8.31-2.82-7.6-2.82-7.6Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#e1e7ef"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M111.77,424.65s36.62-8.45,45.77-4.51c0,0-3.38-20.7-2.82-24.5s-.14-17.05-.14-17.05-2.11-24.64.71-31.54,1.26-25.21,1.26-25.21l-41.68,19.85S114.31,419.15,111.77,424.65Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.93,423.8s36.61-8.45,45.77-4.51c0,0-3.38-20.7-2.82-24.5s-.14-17-.14-17-2.11-24.65.7-31.55,1.27-25.2,1.27-25.2L114,340.85S113.46,418.31,110.93,423.8Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#67647e"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.3,155.33c-1.71-4.35-1-9.42.69-13.82,1.74-4.62,4.41-8.81,6.32-13.35a21,21,0,0,0,2-9.8,1,1,0,0,0,0-.16,12.08,12.08,0,0,1,.87,3.54,21,21,0,0,1-2,9.8c-1.91,4.54-4.57,8.73-6.31,13.35A22.32,22.32,0,0,0,304.3,155.33Z",
    transform: "translate(-49.43 -54.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.54,163a5.17,5.17,0,0,0,2.45-1.93c6.14-7.67,7.45-18.37,12.94-26.54,2-2.92,4.57-5.56,7.86-6.64s7.33-.26,9.36,2.62c1.29,1.82,1.65,4.2,3,6,2.58,3.39,7.53,3.3,11.68,2.67s8.87-1.34,12.08,1.42,3.43,7.53,6,10.74c3.11,3.87,8.58,4.4,13.47,4.61a13.65,13.65,0,0,0,1,3.39c-4.94-.2-10.5-.71-13.65-4.62-2.58-3.21-2.91-8.06-6-10.74s-7.94-2.06-12.08-1.42-9.1.72-11.67-2.67c-1.34-1.77-1.71-4.15-3-6-2-2.88-6.07-3.7-9.36-2.62s-5.9,3.72-7.87,6.64c-5.49,8.17-6.8,18.87-12.94,26.54a5.1,5.1,0,0,1-2.44,1.93c-2.64.74-4.72-2.61-4.71-5.42v-.13C222.53,162.39,223.93,163.47,225.54,163Z",
    transform: "translate(-49.43 -54.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,143.11c1.27,2.06,3.17,3.78,3.83,6.12a7.39,7.39,0,0,1,.27,2c-.86-1.68-2.25-3.1-3.25-4.72a15.46,15.46,0,0,1-2-5.79A14,14,0,0,0,217.3,143.11Z",
    transform: "translate(-49.43 -54.77)"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 808.62,
    cy: 660.81,
    rx: 79.78,
    ry: 12.24,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.42,
    cy: 784.4,
    rx: 39.46,
    ry: 6.06,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 641.1,
    cy: 753.13,
    rx: 39.46,
    ry: 6.06,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 459.31,
    cy: 709.39,
    rx: 39.46,
    ry: 6.06,
    fill: "#009ddd",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 577.51,
    cy: 673.06,
    rx: 39.46,
    ry: 6.06,
    fill: "#009ddd",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.5,659s6.64,8.69-3.07,21.8S1040.72,705,1044,713.13c0,0,14.64-24.35,26.57-24.69S1074.61,673.62,1061.5,659Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#009ddd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.5,659a10.93,10.93,0,0,1,1.36,2.73c11.63,13.66,17.83,26.42,6.64,26.74-10.41.29-22.91,18.92-25.9,23.62a10.34,10.34,0,0,0,.36,1.07s14.64-24.35,26.57-24.69S1074.61,673.62,1061.5,659Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.85,670c0,3.06-.35,5.54-.77,5.54s-.77-2.48-.77-5.54.43-1.61.86-1.61S1073.85,667,1073.85,670Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#ffd037"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.08,673.69c-2.68,1.47-5,2.35-5.22,2s1.81-1.86,4.49-3.32,1.63-.4,1.83,0S1080.77,672.23,1078.08,673.69Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#ffd037"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.41,659s-6.64,8.69,3.07,21.8S1047.19,705,1044,713.13c0,0-14.65-24.35-26.57-24.69S1013.3,673.62,1026.41,659Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#009ddd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.41,659a10.74,10.74,0,0,0-1.35,2.73c-11.63,13.66-17.83,26.42-6.65,26.74,10.41.29,22.91,18.92,25.9,23.62a10.28,10.28,0,0,1-.35,1.07s-14.65-24.35-26.57-24.69S1013.3,673.62,1026.41,659Z",
    transform: "translate(-49.43 -54.77)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.07,670c0,3.06.34,5.54.76,5.54s.77-2.48.77-5.54-.43-1.61-.85-1.61S1014.07,667,1014.07,670Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#ffd037"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.83,673.69c2.68,1.47,5,2.35,5.23,2s-1.81-1.86-4.5-3.32-1.62-.4-1.82,0S1007.15,672.23,1009.83,673.69Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#ffd037"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 994.53,
    cy: 714.15,
    rx: 69.45,
    ry: 10.66,
    fill: "#009ddd",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.7,701.43l-.33,2.71-.47,3.83-.19,1.6-.47,3.83-.2,1.6-.46,3.83-5.32,43.56c-.47,3.89-6.83,6.92-14.5,6.92h-27.61c-7.67,0-14-3-14.49-6.92l-5.32-43.56-.47-3.83-.19-1.6-.48-3.83L1009,708l-.46-3.83-.34-2.71c-.26-2.2,3.17-4.06,7.51-4.06h56.48C1076.53,697.37,1080,699.23,1079.7,701.43Z",
    transform: "translate(-49.43 -54.77)",
    fill: "#65617d"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1029.94 649.37 1029.47 653.19 959.58 653.19 959.12 649.37 1029.94 649.37",
    fill: "#9d9cb5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "1029.28 654.79 1028.82 658.63 960.25 658.63 959.78 654.79 1029.28 654.79",
    fill: "#9d9cb5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "1028.61 660.22 1028.15 664.05 960.91 664.05 960.45 660.22 1028.61 660.22",
    fill: "#9d9cb5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.59c117059c799472eae86834a7e07ce2.svg";
export { ForwardRef as ReactComponent };